import React from "react";
import { Stack, TextField } from "@mui/material";
import CareSettingAutocomplete from "./CareSettingAutocomplete";

export const getReliableCareOwnerName = (child = {}) => {
  const owner = child?.users?.care_owner_details || child?.users?.care_owner;
  if (!owner || typeof owner !== "object") return "";

  return String(owner.displayName || owner.name || "").trim();
};

const PersonAdministrativeFields = ({
  careContext = {},
  onCareSettingChange,
  emergencyContacts = "",
  onEmergencyContactsChange,
  child = {},
  suggestedCareSettings = [],
  fieldSx = {},
}) => {
  const primaryCaregiver = getReliableCareOwnerName(child);

  return (
    <Stack spacing={1.2}>
      <CareSettingAutocomplete
        suggestedOptions={suggestedCareSettings}
        value={careContext?.careSetting || []}
        onChange={onCareSettingChange}
        sx={fieldSx}
      />
      <TextField
        label="Emergency contacts (optional)"
        variant="outlined"
        fullWidth
        multiline
        minRows={2}
        value={emergencyContacts || ""}
        onChange={(event) => onEmergencyContactsChange?.(event.target.value)}
        helperText="Add who to contact first, phone numbers, or important backup contact notes."
        placeholder="Mom: 555-123-4567. Backup: Aunt Priya, 555-222-3333."
        sx={fieldSx}
      />
      {primaryCaregiver ? (
        <TextField
          label="Primary caregiver"
          variant="outlined"
          fullWidth
          value={primaryCaregiver}
          InputProps={{ readOnly: true }}
          helperText="Based on the current Care Owner."
          sx={fieldSx}
        />
      ) : null}
    </Stack>
  );
};

export default PersonAdministrativeFields;
